import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_flex = _resolveComponent("v-flex")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_flex, {
      "data-testid": "ProviderAnalysisModule",
      class: "text-xs-left hidden-sm-and-down"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_btn, {
          text: "",
          class: "back-btn",
          onClick: _ctx.redirectToListProvidersPage
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, {
              class: "v-icon--small",
              left: ""
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode("fa-chevron-left", -1)
              ]))]),
              _: 1
            }),
            _cache[1] || (_cache[1] = _createElementVNode("span", null, "Go back", -1))
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }),
    (_ctx.moduleIsReady)
      ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, "Loading Analysis..."))
  ]))
}